import { FC } from 'react';
import { Box } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import styles from 'pages/contacts/Contacts.module.css';

export const Contacts: FC = () => {
    return (
        <Box className={styles.contentBox}>
            <Box className={styles.columnText}>
                <p className={styles.title}>Телефон медицинского пульта</p>
                <p className={styles.infoText}>
                    <span className={styles.icon}><PhoneIcon /></span>
                    <a href="tel:+88002000062" className={styles.link}>8 (800) 200-00-62</a>
                </p>
            </Box>
            <Box className={styles.columnText}>
                <p className={styles.title}>Служба контроля качества</p>
                <p className={styles.infoText}>
                    <span className={styles.icon}><EmailIcon /></span>
                    <a href="mailto:service@ugsk.ru" className={styles.link}>service@ugsk.ru</a>
                </p>
            </Box>
        </Box>
    );
};

export default Contacts;
